import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Modal, notification, DatePicker } from 'antd';
// import AddCircleIcon from '@material-ui/icons/AddCircle';
// import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
// import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import * as SignalR from '@aspnet/signalr';
import moment from 'moment';
import 'antd/dist/antd.css';

const { Title } = Typography;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'BookingTransactionStore'
)
@observer
class BookingTransactionListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            fromDate: undefined,
            toDate: undefined,
            roomNumber: '',
            pagination: {
                current: 1,
                pageSize: 10,
            }
        }
    }

    componentDidMount() {
        let fromDateTime = moment();
        fromDateTime.hour(0);
        fromDateTime.minute(0);
        fromDateTime.second(0);

        let toDateTime = moment();
        toDateTime.hour(23);
        toDateTime.minute(59);
        toDateTime.second(0);

        this.setState({
            fromDate: fromDateTime,
            toDate: toDateTime,
            roomNumber: ''
        }, () => {
            const { pagination } = this.state;
            this.getFilterData({ pagination });
        });

        // ---------------------------------------------------------------------------
        // SETUP SIGNAL R
        // ---------------------------------------------------------------------------

        let connection = new SignalR.HubConnectionBuilder()
            .withUrl(REACT_APP_SIGNALR_URL)
            .build();

        connection.start().catch(function (err) {
            console.error('Signal R Error in Booking Transaction Main Page');
            return console.error(err.toString());
        });

        // ---------------------------------------------------------------------------
        // SIGNAL R SYNC DATA
        // ---------------------------------------------------------------------------

        console.log(`[SignalR] Listening SignalR_SyncData to sync data from server........`);
        connection.on(`SignalR_SyncData`, () => {
            console.log('[SignalR] Received SignalR_SyncData event to sync data from server: ');
            const { pagination } = this.state;
            this.getFilterData({ pagination });
        })

        // ---------------------------------------------------------------------------
        // END UP SIGNAL R
        // ---------------------------------------------------------------------------
    }

    // Server Table Pagination

    getFilterData = (params = {}) => {
        const fromDate = moment(this.state.fromDate).format('YYYY-MM-DDTHH:mm:ss')
        const endDate = moment(this.state.toDate).format('YYYY-MM-DDTHH:mm:ss')

        this.props.BookingTransactionStore.initBookingTransaction(
            fromDate,
            endDate,
            params.pagination.current,
            params.pagination.pageSize,
            this.state.roomNumber
        ).then(() => {
            const { totalData } = this.props.BookingTransactionStore;

            this.setState({
                pagination: {
                    ...params.pagination,
                    total: totalData
                }
            })
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getFilterData({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    // ON CLICK

    createBookingTransactionOnClick = () => {
        this.props.BookingTransactionStore.initCreateBookingTransaction();
    }

    updateBookingTransactionOnClick = (id) => {
        this.props.BookingTransactionStore.initUpdateBookingTransaction(id);
    }

    deleteBookingTransactionOnClick = (id) => {
        Modal.confirm({
            title: 'Delete Booking Transactin',
            content: 'Are you sure to delete this transaction?',
            okText: 'Yes',
            cancelText: 'Cancel',
            onOk: () => { this.deleteUpdateBookingTransactionOnOk(id); }
        });
    }

    // ON OK

    deleteUpdateBookingTransactionOnOk = (id) => {
        this.props.BookingTransactionStore.deleteUpdateBookingTransaction(id).then(response => {
            if (response.isSuccess) {
                const { pagination } = this.state;
                this.getFilterData({ pagination });
                notification['success']({
                    message: 'Success',
                    description: 'Booking Category has been successfully updated.',
                    duration: 3
                });
            } else {
                notification['error']({
                    message: 'Error',
                    description: `${response.error}`,
                    duration: 3
                });
            }
        });
    }

    // TABLE SETTING

    getColumns = () => {
        return [
            {
                title: 'Booking Date',
                dataIndex: 'bookingDate',
                key: 'bookingDate',
                ...this.getColumnSearchProps('bookingDate')
            },
            {
                title: 'Room',
                dataIndex: 'roomNumber',
                key: 'roomNumber',
                ...this.getColumnSearchProps('roomNumber')
            },
            {
                title: 'Booking By',
                dataIndex: 'bookingBy',
                key: 'bookingBy',
                ...this.getColumnSearchProps('bookingBy')
            },
            {
                title: 'Category',
                dataIndex: 'bookingCategoryName',
                key: 'bookingCategoryName',
                ...this.getColumnSearchProps('bookingCategoryName')
            },
            {
                title: 'Sub Category',
                dataIndex: 'bookingSubCategoryName',
                key: 'bookingSubCategoryName',
                ...this.getColumnSearchProps('bookingSubCategoryName')
            },
            {
                title: 'Time',
                dataIndex: 'time',
                key: 'time',
                ...this.getColumnSearchProps('time')
            },
            {
                title: 'Action',
                dataIndex: 'id',
                key: 'id',
                render: id => (
                    <span>
                        {/* <Button onClick={() => this.updateBookingTransactionOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button> */}
                        <Button onClick={() => this.deleteBookingTransactionOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    fromDateChange = (e) => {
        this.setState({
            fromDate: e
        })
    }

    toDateChange = (e) => {
        this.setState({
            toDate: e
        })
    }

    roomNumberChange = (e) => {
        this.setState({
            roomNumber: e.target.value
        })
    }

    searchData = () => {
        const { pagination } = this.state;
        this.getFilterData({ pagination });
    }

    render() {
        const {
            bookingTransactions,
            bookingTransactionListLoading
        } = this.props.BookingTransactionStore;

        const { pagination } = this.state;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3}>List</Title>
                        {/* <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createBookingTransactionOnClick}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div> */}
                        <div style={{ display: 'flex', alignItems: 'center', height: 48 }}>
                            <div style={{ paddingRight: 8 }}>From Date</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.fromDate}
                                    onChange={(e) => this.fromDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>To Date</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.toDate}
                                    onChange={(e) => this.toDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>Room Number</div>
                            <div style={{ paddingRight: 16 }}>
                                <Input value={this.state.roomNumber} placeholder='Room Number' onChange={this.roomNumberChange} />
                            </div>
                            <div>
                                <Button onClick={this.searchData}>Search</Button>
                            </div>
                        </div>
                    </div>
                    <Spin spinning={bookingTransactionListLoading}>
                        <Table
                            columns={this.getColumns()}
                            rowKey={record => record.id}
                            dataSource={bookingTransactions}
                            pagination={pagination}
                            onChange={this.handleTableChange} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default BookingTransactionListPage;
